import React from 'react';
import PropTypes from 'prop-types';
import styles from './ResultTitle.module.css';

const ResultTitle = ({ title, suffix, viewLabel }) => {
  return (
    <div className={styles.container} style={{ display: 'flex' }}>
      <p style={{ padding: '0', margin: '0' }}>{title ? title : `Results`}</p>
      {viewLabel && (
        <div
          style={{
            background: '#6c757d',
            color: 'white',
            fontWeight: '500',
            padding: '4px 10px',
            borderRadius: '20px',
            fontSize: '14px',
            maxHeight: '26px',
            margin: '5px 0 0 5px',
          }}
        >
          {viewLabel}
        </div>
      )}
      {suffix && (
        <div
          style={{
            background: '#4767FF',
            color: 'white',
            fontWeight: '500',
            padding: '4px 10px',
            borderRadius: '20px',
            fontSize: '14px',
            maxHeight: '26px',
            margin: '5px 0 0 5px',
          }}
        >
          {suffix}
        </div>
      )}
    </div>
  );
};

ResultTitle.propTypes = {
  title: PropTypes.string,
  suffix: PropTypes.string,
  viewLabel: PropTypes.string,
};

export default ResultTitle;
